import { Button, Divider, Empty, Select } from "antd";
import { QFTitle } from "@qualitas/qf-title";
import StepsButtons from "../CommonComponents/StepsButtons";
import {
  CloseOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import FormInput from "../CommonComponents/FormInput";
import FormSelect from "../CommonComponents/FormSelect";
import FormUpload from "../CommonComponents/FormUpload";
import FormDatePicker from "../CommonComponents/FormDatePicker";
import { IBeneficialOwnersProps } from "../IDataCollection";

const BeneficialOwners = (props: IBeneficialOwnersProps) => {
  const {
    selectedInvestor,
    advanceStep,
    translations,
    goBackStep,
    onChangeInvestor,
    onAddItem,
    onRemoveItem,
    countries,
    errors,
    isOcrLoading,
    handleBeforeUpload,
	language
  } = props;

  return (
    <div className="investor-step">
      <label className="investor-select">Inversor:</label>
      <Select
        style={{ width: "100%" }}
        placeholder={selectedInvestor?.institutionLong}
        disabled
      />
      <Divider />
      <div className="investor-step-header">
        <QFTitle title={translations?.beneficialOwners} size="extrabig" />
        <Button
          icon={<PlusCircleOutlined />}
          onClick={() => onAddItem("beneficialOwners")}
        >
          {translations?.add}
        </Button>
      </div>
      <div>
        {selectedInvestor?.beneficialOwners?.length > 0 &&
          selectedInvestor?.beneficialOwners.map(
            (owner: any, index: number) => {
              return (
                <div key={index}>
                  <Divider />
                  <p className="investor-step-title">
                    {translations?.beneficialOwnersData} {index + 1}
                    <Button
                      type="text"
                      icon={<CloseOutlined />}
                      onClick={() => onRemoveItem("beneficialOwners", index)}
                    />
                  </p>
                  <div className="investor-step-form-row">
                    <FormInput
                      mandatory
                      field="name"
                      error={errors?.beneficialOwners?.[index]?.name}
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      value={owner?.name || ""}
                      label={translations.names}
                      placeholder={translations?.completeField}
                    />
                    <FormInput
                      mandatory
                      field="firstLastName"
                      error={errors?.beneficialOwners?.[index]?.firstLastName}
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      value={owner?.firstLastName || ""}
                      label={translations.firstLastName}
                      placeholder={translations?.completeField}
                    />
                    <FormInput
                      field="secondLastName"
                      error={errors?.beneficialOwners?.[index]?.secondLastName}
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      value={owner?.secondLastName || ""}
                      label={translations.secondLastName}
                      placeholder={translations?.completeField}
                    />
                    <FormSelect
                      mandatory
                      field="isPrp"
                      label={translations?.isPrp}
                      index={index}
                      arrayField="beneficialOwners"
                      value={owner?.isPrp || false}
                      options={[
                        { id: true, name: translations.yes },
                        { id: false, name: "No" },
                      ]}
                      optionField="id"
                      optionName="name"
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      placeholder={translations?.selectAnOption}
					  tooltip={translations?.prpDisclaimer1}
                    />

                    <FormInput
                      field="prpPosition"
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      value={owner?.prpPosition || ""}
                      label={translations.prpPosition}
                      disabled={!owner?.isPrp}
                      placeholder={translations?.completeField}
					  tooltip={translations?.prpDisclaimer2}
                    />
                    <FormSelect
                      field="taxCountry"
                      label={translations?.taxCountry}
                      error={errors?.beneficialOwners?.[index]?.taxCountry}
                      index={index}
                      mandatory
                      arrayField="beneficialOwners"
                      value={owner?.taxCountry}
                      options={countries}
                      optionField="idCountry"
            			optionName={language === "es" ? "name_lang2" : "name_lang1"}
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      placeholder={translations?.selectAnOption}
                    />
                    <FormUpload
                      mandatory
                      translations={translations}
                      label={translations?.identityDocument}
                      uploadedFile={owner?.documentFile}
                      error={errors?.beneficialOwners?.[index]?.documentFile}
                      handleBeforeUpload={(e: any) =>
                        handleBeforeUpload(
                          e,
                          true,
                          "documentFile",
                          index,
                          "beneficialOwners"
                        )
                      }
                      isOcrLoading={
                        isOcrLoading?.[`beneficialOwners_${index}`] || false
                      }
                    />
                    <FormInput
                      label={translations?.documentNumber}
                      mandatory
                      error={errors?.beneficialOwners?.[index]?.documentNumber}
                      field="documentNumber"
                      isOcrLoading={
                        isOcrLoading?.[`beneficialOwners_${index}`] || false
                      }
                      index={index}
                      arrayField="beneficialOwners"
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      value={owner?.documentNumber || ""}
                      placeholder={translations?.completeField}
					  translations={translations}
                    />
                    <FormDatePicker
                      label={translations?.dateOfExpiration}
                      field="dateOfExpiration"
                      mandatory
                      error={errors?.beneficialOwners?.[index]?.dateOfExpiration}
                      value={owner?.dateOfExpiration}
                      index={index}
					  translations={translations}
                      arrayField="beneficialOwners"
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      placeholder={translations?.selectADate}
                      isOcrLoading={
                        isOcrLoading?.[`beneficialOwners_${index}`] || false
                      }
                    />
                    <FormDatePicker
                      label={translations?.dateOfBirth}
                      field="dateOfBirth"
                      value={owner?.dateOfBirth}
                      index={index}
                      error={errors?.beneficialOwners?.[index]?.dateOfBirth}
                      mandatory
                      arrayField="beneficialOwners"
					  translations={translations}
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      placeholder={translations?.selectADate}
                      isOcrLoading={
                        isOcrLoading?.[`beneficialOwners_${index}`] || false
                      }
                    />
					<FormSelect
                      field="nationality"
                      label={translations?.nationality}
                      error={errors?.beneficialOwners?.[index]?.nationality}
                      index={index}
                      mandatory
                      arrayField="beneficialOwners"
                      value={owner?.nationality}
                      options={countries}
                      optionField="name_lang2"
            		  optionName={language === "es" ? "name_lang2" : "name_lang1"}
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      placeholder={translations?.selectAnOption}
                    />
                    <FormInput
                      numeric
                      label={translations?.participationPercentage}
                      error={
                        errors?.beneficialOwners?.[index]
                          ?.participationPercentage
                      }
                      mandatory
                      field="participationPercentage"
                      index={index}
                      arrayField="beneficialOwners"
                      onChangeInvestor={(value: any, field: any) =>
                        onChangeInvestor(
                          value,
                          field,
                          index,
                          "beneficialOwners"
                        )
                      }
                      value={owner?.participationPercentage || 0}
                      placeholder={translations?.completeField}
                    />
                  </div>
                  <p className="form-disclaimer">
                    {translations?.verifyDocument}
                  </p>
                  <FormUpload
                    mandatory
                    translations={translations}
                    label={translations?.beneficialOwnersFile}
                    uploadedFile={owner?.beneficialOwnersFile}
                    oneRow
                    error={
                      errors?.beneficialOwners?.[index]
                        ?.beneficialOwnersFile
                    }
                    handleBeforeUpload={(e: any) =>
                      handleBeforeUpload(
                        e,
                        false,
                        "beneficialOwnersFile",
                        index,
                        "beneficialOwners"
                      )
                    }
                  />
                </div>
              );
            }
          )}
        {selectedInvestor?.beneficialOwners?.length === 0 && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={translations?.noBeneficialOwners}
          />
        )}
      </div>
      <Divider />
      <StepsButtons
        advanceStep={advanceStep}
        goBackStep={goBackStep}
        steps={4}
        currentStep={2}
        translations={translations}
        nextText={translations?.next}
      />
    </div>
  );
};

export default BeneficialOwners;
